var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 14C27 6.8203 21.1797 0.999999 14 1C6.8203 1 0.999999 6.8203 0.999999 14C1 21.1797 6.8203 27 14 27C21.1797 27 27 21.1797 27 14Z",
    stroke: "#FFF057",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1295_15706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90814 16.216C10.2095 15.9333 10.6803 15.9333 10.9816 16.216L13.2605 18.3719V10.5312C13.2548 10.5047 13.2511 10.4782 13.2511 10.4517V7.58017C13.2511 7.36635 13.4356 7.19141 13.6654 7.19141H14.3716C14.5995 7.19141 14.786 7.36458 14.786 7.58017V8.97971H14.7916C14.7916 9.01329 14.786 9.0451 14.786 9.07867V18.3719L17.0648 16.2337C17.3661 15.9509 17.837 15.9509 18.1383 16.2337C18.4396 16.5164 18.4396 16.9582 18.1383 17.2409L14.56 20.5984C14.2586 20.8811 13.7878 20.8811 13.4865 20.5984L9.90814 17.2409C9.75748 17.0995 9.68215 16.9228 9.68215 16.7285C9.68215 16.5517 9.75748 16.3574 9.90814 16.216Z",
    fill: "#FFF057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1295_15706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.68214,
    height: 13.619,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.3643 7.19141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircleIcon);
export default __webpack_public_path__ + "static/media/download-circle-icon.8f54d6bd355641d5077347068a13b08c.svg";
export { ForwardRef as ReactComponent };